module.exports = __webpack_public_path__ + "static/img/jcdldr_1.074e2f1a.png";